import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'

const service = new ApolloClientService()

export default class Customer {
  fetchCompanyCustomers = (params) => {
    return new Promise((resolve, reject) => {
      service
        .fetchCompanyCustomers(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  fetchCases = (params) => {
    console.log('fetchCases customer service params --------->> ', params)

    return new Promise((resolve, reject) => {
      service
        .fetchCases(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getCustomers = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCustomers(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getCustomers2 = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCustomers2(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getCustomer = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCustomer(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getUniqueCustomerCode = () => {
    return new Promise((resolve, reject) => {
      service
        .getUniqueCustomerCode()
        .then((data) => {
          resolve(data)
        })
        .catch((err) => console.log(err))
    })
  }

  getCustomerLogoAndName = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCustomerLogoAndName(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
  getCustomersIdAndNameList = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCustomersIdAndNameList(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  addEditCustomer = (params) => {
    return new Promise((resolve, reject) => {
      service
        .addEditCustomer(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
